import { render, staticRenderFns } from "./TopMenu.vue?vue&type=template&id=b857ab66&scoped=true&"
import script from "./TopMenu.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TopMenu.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TopMenu.vue?vue&type=style&index=0&id=b857ab66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b857ab66",
  null
  
)

export default component.exports